module.exports = __webpack_public_path__ + "img/wwhulk.9755d608.svg";